import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Form, Input, Button, Typography } from 'antd';
import { FormattedMessage } from 'react-intl';
import Messages from 'i18n/messages/login';
import Img from 'common/components/image/Image';

import PRODUCT_HUB_LOGO from 'assets/Blueprint_Logos-ProductHub-White.png';
import BLUEPRINT_DAYMON_LOGO from 'assets/daymon/Blueprint_Daymon.png';

/**
 * Login.js
 * Render the login form component
 * @author Brian Pick
 */

const layout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 18,
  },
};


const { Item } = Form;
const { Password } = Input;
const { Text } = Typography;

/**
 * User login form
 */
function Login(props) {
  const { onFinish, error, branding, usercls, ...rest } = props;

  const { loginType, isHaveLoginSwitch, switchLoading } = rest;

  const logoSrc = isHaveLoginSwitch
    ? loginType === 'daymon'
      ? BLUEPRINT_DAYMON_LOGO
      : PRODUCT_HUB_LOGO
    : PRODUCT_HUB_LOGO;

  return (
    <Form
      {...layout}
      name='login-form'
      className={`form  ${usercls}`}
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      {...rest}
    >
      <div className='form__branding'>
        <Img
          src={logoSrc}
          alt={(branding && branding.name) || 'product hub'}
          className='form__image'
        />
        <Typography.Paragraph className='form__text'>
          Through our variety of proprietary tools, Daymon Blueprint Product
          Hub™ unifies and automates your product data.
        </Typography.Paragraph>
      </div>
      <div className='form__submit'>
        <Item
          label={<FormattedMessage {...Messages.userNameWithColon} />}
          name='userName'
          colon={false}
          rules={[
            {
              required: true,
              message: <FormattedMessage {...Messages.usernameRequired} />,
            },
          ]}
        >
          <Input />
        </Item>

        <Item
          label={<FormattedMessage {...Messages.passwordWithColon} />}
          name='password'
          colon={false}
          rules={[
            {
              required: true,
              message: <FormattedMessage {...Messages.passwordRequired} />,
            },
          ]}
        >
          <Password />
        </Item>

        <Link className='form__link form__link-forgot' to='/forgot'>
          <FormattedMessage {...Messages.forgot} />
        </Link>

        <div className='form__button'>
          <Button
            type='primary'
            shape='round'
            className={`form__btn form__btn-submit login-form__action-submmit-btn`}
            htmlType='submit'
            loading={switchLoading}
          >
            <Text style={{ color: 'white' }}>
              <FormattedMessage {...Messages.login} />
            </Text>
          </Button>
        </div>
      </div>

      <Text className={`${usercls}-error-message`} type='danger'>
        {error && error}
      </Text>
    </Form>
  );
}

Login.propTypes = {
  /**
   * a submit action to send post login data
   */
  onFinish: PropTypes.func,
  /**
   * response an error for displaying indication message
   */
  error: PropTypes.string,
};

export default Login;
